const DEFAULTS = {
  classes: {
    invalidField: 'form__field--invalid',
    visibleMessageField: 'form__field-message--visible',
  },
  selectors: {
    button: '[data-comp-form-submit-button]',
    buttonIcon: '.button__arrow',
    buttonLoader: '.button__loader',
    buttonText: '.button__text',
    field: '[data-comp-form-field]',
    form: '[data-comp-form]',
    input: '[data-comp-form-field-input]',
    messageContainer: '[data-comp-form-message]',
    successMessage: '[data-comp-form-success-message]',
    textarea: '[data-comp-form-textarea]',
    labelSelector: '[data-comp-form-field-label]',
    confettiCanvas: '[data-comp-form-confetticanvas]',
    baseFormContent: '[data-comp-form-base-form-content]',
    postSubmitContent: '[data-comp-form-post-submit-content]',
  },
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.2,
  },
};

const confettiOptions = {
  particles: [
    {
      particleCountModifier: 0.25,
      spread: 26,
      startVelocity: 55,
    },
    {
      particleCountModifier: 0.2,
      spread: 60,
    },
    {
      particleCountModifier: 0.35,
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
    },
    {
      particleCountModifier: 0.1,
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
    },
    {
      particleCountModifier: 0.1,
      spread: 120,
      startVelocity: 45,
    },
  ],
};

export {
  DEFAULTS,
  confettiOptions,
};
